/** Робота з датами. Усе — у локальному часі користувача. */

/** Час «перевороту доби»: до 4:00 ранку день вважається попереднім (як в Anki). */
export const ROLLOVER_HOUR = 4

export const MINUTE = 60_000
export const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR

/** Початок навчальної доби, до якої належить момент `ts`. */
export function dayStart(ts: number, rollover = ROLLOVER_HOUR): number {
  const d = new Date(ts)
  d.setHours(rollover, 0, 0, 0)
  const start = d.getTime()
  return start > ts ? start - DAY : start
}

/** Ключ доби у форматі `YYYY-MM-DD` (за навчальною добою). */
export function dayKey(ts: number, rollover = ROLLOVER_HOUR): string {
  const d = new Date(dayStart(ts, rollover))
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

/** Розбирає `YYYY-MM-DD` у момент початку тієї навчальної доби. */
export function fromDayKey(key: string, rollover = ROLLOVER_HOUR): number {
  const [y, m, d] = key.split('-').map(Number)
  return new Date(y!, (m ?? 1) - 1, d ?? 1, rollover, 0, 0, 0).getTime()
}

/** Скільки цілих навчальних діб від `from` до `to` (може бути відʼємним). */
export function daysBetween(from: number, to: number, rollover = ROLLOVER_HOUR): number {
  return Math.round((dayStart(to, rollover) - dayStart(from, rollover)) / DAY)
}

/** Додає `n` діб до моменту. */
export function addDays(ts: number, n: number): number {
  const d = new Date(ts)
  d.setDate(d.getDate() + n)
  return d.getTime()
}

/** Людський підпис для кількості днів: «сьогодні», «завтра», «через 5 днів». */
export function humanDays(n: number): string {
  if (n <= 0) return 'сьогодні'
  if (n === 1) return 'завтра'
  if (n === 2) return 'післязавтра'
  const last = n % 10
  const two = n % 100
  if (two >= 11 && two <= 14) return `через ${n} днів`
  if (last === 1) return `через ${n} день`
  if (last >= 2 && last <= 4) return `через ${n} дні`
  return `через ${n} днів`
}
